export default "__VITE_ASSET__TqJtE5zi__"